import React from 'react';
import { motion } from 'framer-motion';
import { Calendar, FileText, Zap, Music, Smartphone, Award } from 'lucide-react';
import { BonusMockup } from '../mockups/ProductMockups';
const bonuses = [{
  id: 1,
  icon: <Calendar className="w-8 h-8" data-id="element-61" />,
  title: 'Agenda de Planificación Semanal',
  desc: 'Tu año lectivo organizado. Calendario de objetivos, plantillas semanales y planificador de muestra anual. De 3 horas de planificación dominical a 7 minutos.',
  color: 'wine'
}, {
  id: 2,
  icon: <FileText className="w-8 h-8" data-id="element-62" />,
  title: 'Fichas de Seguimiento del Alumno',
  desc: 'Ficha de ingreso, mapa de progreso por nivel y reporte trimestral para padres listo para completar. El documento que justifica cualquier aumento de cuota.',
  color: 'cream'
}, {
  id: 3,
  icon: <Zap className="w-8 h-8" data-id="element-63" />,
  title: 'Pack de Dinámicas Salva-Clases',
  desc: '12 actividades de inicio, 10 tickets de salida y 6 cierres de clase. Para los días donde el grupo entra como si hubiera tomado demasiado azúcar.',
  color: 'plum'
}, {
  id: 4,
  icon: <Music className="w-8 h-8" data-id="element-64" />,
  title: 'Banco de Música y Recursos Sonoros',
  desc: 'La guía definitiva de música para cada momento de la clase. Listas curadas por nivel, repertorio clásico esencial y el protocolo para cuando la tecnología falla.',
  color: 'wine'
}, {
  id: 5,
  icon: <Smartphone className="w-8 h-8" data-id="element-65" />,
  title: 'Manual de Comunicación con Padres',
  desc: 'Plantillas de WhatsApp listas para cobrar, citar y responder quejas. El sistema para pasar de "la chica que baila" a "Directora de Academia".',
  color: 'cream'
}, {
  id: 6,
  icon: <Award className="w-8 h-8" data-id="element-66" />,
  title: 'Certificados y Reconocimientos Imprimibles',
  desc: 'Diplomas de graduación, premios semanales e invitaciones para la muestra. El cierre emocional que fideliza a tus alumnos para siempre.',
  color: 'gold'
}];
export function BonusSection() {
  return <section className="py-20 bg-cream-50 relative overflow-hidden" data-id="element-67">
      <div className="max-w-6xl mx-auto px-4" data-id="element-68">
        <div className="text-center mb-12 flex flex-col items-center" data-id="element-69">
          <h2 className="font-serif text-4xl font-bold text-gray-900 mb-4" data-id="element-70">
            + 6 Regalos Estratégicos
          </h2>
          <p className="text-xl text-gray-600 font-medium mb-8" data-id="element-71">
            Incluidos sin costo extra · Valor real del pack
          </p>
          <div className="bg-wine-600 text-white py-3 px-8 rounded-full font-bold text-lg shadow-md inline-flex items-center gap-2" data-id="element-72">
            <span data-id="element-73">🎁</span> GRATIS POR EL DÍA DE HOY
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-74">
          {bonuses.map((bonus, idx) => <motion.div key={bonus.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1
        }} className="bg-white rounded-3xl p-8 shadow-sm border border-cream-100 hover:shadow-md transition-all flex flex-col items-center text-center" data-id="element-75">
              <div className="mb-8 w-full" data-id="element-76">
                <BonusMockup id={bonus.id} icon={bonus.icon} colorClass={bonus.color} data-id="element-77" />
              </div>

              <div className="bg-gold-100 text-gold-800 text-xs font-bold px-4 py-1.5 rounded-full uppercase tracking-wider mb-5" data-id="element-78">
                GRATIS
              </div>

              <h3 className="font-serif text-xl font-bold text-gray-900 mb-3 flex items-center justify-center gap-2" data-id="element-79">
                Bonus {bonus.id} — {bonus.title}
              </h3>

              <p className="text-gray-600 text-sm leading-relaxed" data-id="element-80">
                {bonus.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}